<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <header class="text-center pb-4 border-b border-grey">
      <h3
        class="mt-0 font-bold"
        v-text="'Update Groups'"
      />
      <div class="flex justify-center items-baseline mt-4">
        <div class="input-group">
          <input
            v-model="search"
            class="input"
            placeholder="Filter"
            type="text"
          >
        </div>
        <div class="text-xs pl-4">
          <a
            href="#"
            @click.prevent="selectAll"
            v-text="'Select All'"
          />
          |
          <a
            href="#"
            @click.prevent="selectNone"
            v-text="'Select None'"
          />
        </div>
      </div>
    </header>
    <div class="modal-body">
      <div
        v-if="loading"
        class="load load--fill h-24"
      />
      <div v-else>
        <ul
          v-if="membershipGroups.length"
          class="scroll-checklist scroll-blue"
        >
          <li
            v-for="group in membershipGroups"
            :key="group.uuid"
          >
            <input
              :id="`${id}${group.uuid}`"
              v-model="selectedGroups"
              :value="group"
              type="checkbox"
            >
            <label
              :for="`${id}${group.uuid}`"
              class="checkbox"
              v-text="group.attributes.title"
            />
          </li>
        </ul>
        <p
          v-else
          class="text-center"
          v-text="'No groups match your search'"
        />
      </div>
    </div>
    <div class="flex justify-center items-baseline modal-footer text-center mt-4">
      <button
        type="button"
        class="btn"
        @click="save"
        v-text="'Save'"
      />
      <a
        class="mx-4"
        href="#"
        @click.prevent="close"
        v-text="'Cancel'"
      />
    </div>
  </BaseModal>
</template>

<script type="text/babel">
import { debounce, uniq } from 'lodash'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'GroupSelectorModal',
  props: {
    id: {
      type: String,
      required: false,
      default: '',
    },
    show: {
      type: Boolean,
      required: true,
    },
    preselectedGroups: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      search: '',
      selectedGroupUuids: [],
      selectedGroups: [],
      loading: false,
    }
  },
  computed: {
    ...mapState({
      membershipGroups: state => state.membership.membershipGroups.data,
    }),
  },
  watch: {
    show() {
      if (this.show) {
        if (!this.membershipGroups.length) {
          this.loading = true

          this.fetchMembershipGroups().then(() => this.loading = false)
        }
      }
    },
    preselectedGroups(){
      const vm = this
      _.forEach(this.preselectedGroups, function (group) {
        if (_.find(vm.preselectedGroups, { uuid: group.uuid }) === -1) {
          vm.selectedGroups.push(group)
        }
      })
    },
    search: debounce(function () {
      this.fetchMembershipGroups({
        params: {
          query: this.search,
        },
      })
    }, 500),
  },
  mounted() {
    this.selectedGroups = this.preselectedGroups
  },
  methods: {
    ...mapActions({
      fetchMembershipGroups: 'membershipGetMembershipGroups',
    }),
    save() {
      this.$emit('updateSelectedGroups', this.selectedGroups)
      this.$emit('updateSelectedGroupUuids', this.selectedGroupUuids)

      this.close()
    },
    selectAll() {
      const all = _.map(this.membershipGroups, 'uuid')

      this.selectedGroupUuids = uniq(this.selectedGroupUuids.concat(all))
    },
    selectNone() {
      this.selectedGroupUuids = []
    },
    close() {
      this.$emit('close')

      this.search = ''
      this.selectedGroupUuids = []
    },
    isSelected(group) {
      return _.findIndex(this.selectedGroupUuids, { uuid: group.uuid }) > -1
    },
    deselectGroup(group) {
      const index = _.findIndex(this.selectedGroupUuids, { uuid: group.uuid })

      if (index > -1) {
        this.selectedGroupUuids.splice(index, 1)
      }
    },
    selectGroup(group) {
      const index = _.findIndex(this.selectedGroupUuids, { uuid: group.uuid })

      if (index === -1) {
        this.selectedGroupUuids.push(group)
      }
    },
  },
}
</script>
